import type { MarkdownEditorActions } from "@/Components/NextBase/LimeMarkdownEditor";

// The message-body editors (scheduled message, message template) run the
// same chips-only toolbar, so the rule for what stays enabled lives here
// rather than in each of them: nothing, except the email channel's link
// action. An email body renders as HTML, so a hyperlink survives; a phone
// channel carries the URL as text instead.
const EXCLUDED_ACTIONS: ReadonlyArray<MarkdownEditorActions> = [
  "bold",
  "italic",
  "strike",
  "link",
  "image",
  "unordered-list",
  "ordered-list",
  "horizontal-rule",
  "paragraph",
];

export function messageEditorExcludedActions(
  channel: "sms" | "email",
): MarkdownEditorActions[] {
  return EXCLUDED_ACTIONS.filter(
    (action) => !(channel === "email" && action === "link"),
  );
}
